export const connectionOutcomeText = (outcome: string, expired: boolean) => {
    if (outcome === 'Passed' && expired) {
      return 'Listener Timeout';
    } else if (outcome === 'Passed' && !expired) {
      return 'Listener Passed';
    } else {
      return outcome;
    }
  };